import React from 'react';
import { FaUserCircle } from 'react-icons/fa';

const ProfileForm = ({ 
    editingData, 
    userData, 
    errors, 
    loading, 
    handleInputChange, 
    handleCancel, 
    handleUpdate, 
    setUpdatePasswordModal, 
    setUpdateCardModal 
}) => {
    return (
        <form onSubmit={handleUpdate} className='flex flex-col gap-3 text-xs lg:text-sm'>
            <div className='flex flex-col justify-start gap-4 lg:gap-10'>
                <p className='text-base m-0 p-0 md:text-xl lg:text-2xl font-bold'>Edit Account Profile</p>
                <FaUserCircle className='text-4xl lg:text-[120px]' />
            </div>

            <SectionHeader title="Personal Information" />
            <div className='py-4 lg:py-8 grid sm:grid-cols-2 gap-4'>
                <FormInput
                    label="Admin Name"
                    name="name"
                    value={editingData.name || ''}
                    onChange={handleInputChange}
                    error={errors.name}
                    required
                />
                <FormInput
                    label="Email"
                    name="email"
                    type="email"
                    value={editingData.email || ''}
                    onChange={handleInputChange}
                    error={errors.email}
                    required
                />
            </div>

            <SectionHeader title="Company Information" />
            <div className='py-4 lg:py-8 grid sm:grid-cols-2 gap-4'>
                <FormInput
                    label="Company Name"
                    name="company_name"
                    value={editingData.company_name || ''}
                    onChange={handleInputChange}
                    error={errors.company_name}
                    required
                />
                <FormInput
                    label="Company Mobile Number"
                    name="company_phone"
                    value={editingData.company_phone || ''}
                    onChange={handleInputChange}
                    error={errors.company_phone}
                    required
                />
                
                <span>
                    <p className='text-gray-600 text-sm'>Company Type <span className="text-red-500 text-lg font-bold ml-1">*</span></p>
                    <select
                        name="company_type"
                        value={editingData.company_type || ''}
                        onChange={handleInputChange}
                        className={`w-full p-2 border rounded bg-transparent focus:outline-none ${errors.company_type ? 'border-red-500' : 'border-slate-400'}`}
                        required
                    >
                        <option value="">Select Company Type</option>
                        <option value="hospital">Hospital</option>
                        <option value="pharmacy">Pharmacy</option>
                        <option value="insurance_provider">Insurance Provider</option>
                        <option value="eye_clinic">Eye clinic</option>
                        <option value="medical_clinic">Medical clinic</option>
                        <option value="other">Other</option>
                    </select>
                    {errors.company_type && <p className="text-red-500 text-xs mt-1">{errors.company_type}</p>}
                </span>
                
                <FormInput
                    label="Company Website"
                    name="company_website"
                    value={editingData.company_website || ''}
                    onChange={handleInputChange}
                    placeholder="https://example.com (optional)"
                />
            </div>

            <SectionHeader title="Address Information" />
            <div className='py-4 lg:py-8 grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-y-8'>
                <FormInput
                    label="Company Address"
                    name="address"
                    value={editingData.address || ''}
                    onChange={handleInputChange}
                    error={errors.address}
                    required
                />
                <FormInput
                    label="Country"
                    name="country"
                    value={editingData.country || ''}
                    onChange={handleInputChange}
                    error={errors.country}
                    required
                />
                <FormInput
                    label="City"
                    name="city"
                    value={editingData.city || ''}
                    onChange={handleInputChange}
                    error={errors.city}
                    required
                />
                <FormInput
                    label="Town"
                    name="town"
                    value={editingData.town || ''}
                    onChange={handleInputChange}
                />
                <FormInput
                    label="Zip Code/ Postal Code"
                    name="zip_code"
                    value={editingData.zip_code || ''}
                    onChange={handleInputChange}
                />
            </div>
            
            <SectionHeader title="Card Details" />
            <div className='py-4 lg:py-8 grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-y-8'>
                <span>
                    <p className='text-gray-600 text-sm'>Card number</p>
                    <p className=''>{`**** **** **** ${userData?.pm_last_four}`}</p>
                </span>
                <span>
                    <p className='text-gray-600 text-sm'>Type</p>
                    <p className='font-extrabold'>{userData?.pm_type}</p>
                </span>
                <span>
                    <div className="p-[1.5px] rounded-md bg-gradient-to-r from-green-400 to-blue-600 inline-block">
                        <button
                            type="button"
                            onClick={() => { setUpdateCardModal(true) }}
                            className='px-4 py-2 bg-white text-gray-800 font-semibold rounded-md'>
                            Update card details
                        </button>
                    </div>
                </span>
            </div>

            <SectionHeader title="Account Security" />
            <div className='py-4 lg:py-8 gap-4 sm:gap-y-8'>
                <span>
                    <p className='text-gray-600 text-sm'>Password</p>
                    <div className="p-[1.5px] rounded-md bg-gradient-to-r from-green-400 to-blue-600 inline-block">
                        <button
                            type="button"
                            onClick={() => setUpdatePasswordModal(true)}
                            className="px-4 py-2 bg-white text-gray-800 font-semibold rounded-md"
                        >
                            Change Password
                        </button>
                    </div>
                </span>
            </div>

            <div className='flex justify-end gap-4 m-4'>
                <button
                    type="button"
                    onClick={handleCancel}
                    className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                >
                    Cancel
                </button>

                <button
                    type="submit"
                    disabled={loading}
                    className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-600 dark:focus:ring-blue-900"
                >
                    {loading ? 'Updating...' : 'Update'}
                </button>
            </div>
        </form>
    );
};

const SectionHeader = ({ title }) => (
    <div className='flex flex-row gap-2 items-center mt-2'>
        <div className='h-[15px] bg-blue-400 w-[5px]'></div>
        <p className='text-base md:text-lg font-semibold'>{title}</p>
    </div>
);

const FormInput = ({ label, name, value, onChange, error, type = "text", required = false, placeholder = "" }) => (
    <span>
        <p className='text-gray-600 text-sm'>{label} {required && <span className="text-red-500 text-lg font-bold ml-1">*</span>}</p>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            className={`w-full p-2 border rounded bg-transparent focus:outline-none ${error ? 'border-red-500' : 'border-slate-400'}`}
            required={required}
            placeholder={placeholder}
        />
        {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </span>
);

export default ProfileForm; 